export enum fileSize {
    resume = 5033165,
    photo = 5033165,
    unique_id = 5033165,
}

export enum fileType {
    resume = "resume",
    photo = "photo",
    unique_id = "unique_id",
}